import { Bookmark, Pencil } from "phosphor-react";
import React, { useRef } from "react";
import Button from "~/admin/components/Button";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Notifications from "~/admin/services/Notifications";
import CreateSocialNetworkModal from "./components/CreateSocialNetworkModal";
import UpdateSocialNetworkModal from "./components/UpdateSocialNetworkModal";

export default function SocialNetworksTab({ socialNetworks, reload }) {
  const createSocialNetworkModal = useRef();
  const updateSocialNetworkModal = useRef();

  const onCreated = async (id) => {
    Notifications.success("Réseau social créé avec succès");
    reload();
  };

  const onUpdated = async (id) => {
    Notifications.success("Réseau social modifié avec succès");
    reload();
  };

  return (
    <>
      <Button
        color="tertiary"
        size="s"
        className="mb-4"
        icon={<Bookmark />}
        onClick={() => createSocialNetworkModal.current?.open()}
      >
        Ajouter un réseau social
      </Button>
      <Card>
        <Table>
          <thead>
            <Tr>
              <Th>Nom</Th>
              <Th>Nombre d'influenceurs</Th>
              <Th adaptToContent>Couleur</Th>
              <Th></Th>
            </Tr>
          </thead>
          <tbody>
            {socialNetworks.map((socialNetwork) => {
              return (
                <Tr key={socialNetwork.id}>
                  <Td>{socialNetwork.name}</Td>
                  <Td>{socialNetwork.social_network_accounts_count}</Td>
                  <Td>
                    <div
                      className={`w-6 h-6 rounded-full`}
                      style={{ backgroundColor: socialNetwork.color }}
                    ></div>
                  </Td>
                  <Td isActions>
                    <Pencil
                      className="cursor-pointer hover:text-gray-400"
                      size={24}
                      onClick={() => {
                        updateSocialNetworkModal?.current?.open(
                          socialNetwork.id
                        );
                      }}
                    />
                  </Td>
                </Tr>
              );
            })}
          </tbody>
        </Table>
      </Card>
      <CreateSocialNetworkModal
        ref={createSocialNetworkModal}
        onSubmitted={onCreated}
      />
      <UpdateSocialNetworkModal
        ref={updateSocialNetworkModal}
        onSubmitted={onUpdated}
      />
    </>
  );
}
